(function(){
  if(window.__mxpAddressAmazonV1)return;
  window.__mxpAddressAmazonV1=true;

  var state=null,busy=false,observer=null,timer=null;

  function api(){return window.MaxpromoCustomerAPI||null}
  function arr(c){var a=c&&c.addresses;return Array.isArray(a)?a:(a&&Array.isArray(a.nodes)?a.nodes:[])}
  function sid(v){return String(v==null?'':v)}
  function full(a){
    if(!a)return false;
    var name=String(a.name||[a.firstName,a.lastName].filter(Boolean).join(' ')).trim();
    var phone=String(a.phoneNumber||a.phone||'').trim();
    var country=String(a.country||a.territoryCode||a.countryCode||a.countryCodeV2||'').trim();
    return !!(name&&phone&&String(a.address1||'').trim()&&String(a.city||'').trim()&&String(a.zip||'').trim()&&country);
  }
  function css(){
    if(document.getElementById('mxp-address-amazon-style-v1'))return;
    var s=document.createElement('style');s.id='mxp-address-amazon-style-v1';
    s.textContent=
      '[data-mps-api-panel="addresses"]>.mxp-page-head--row{padding-right:84px!important;position:relative!important}' +
      '[data-mps-api-panel="addresses"] [data-mps-api-address-add]{position:relative!important;z-index:2!important}' +
      '.mxp-address-default-action{border:1px solid #f0b429!important;background:#fff8dc!important;color:#7a5700!important}' +
      '.mxp-address-default-badge{display:inline-flex!important;align-items:center!important;min-height:24px!important;padding:0 9px!important;border-radius:999px!important;background:#fff3bf!important;color:#7a5700!important;font-size:8.5px!important;font-weight:900!important}' +
      '@media(max-width:760px){[data-mps-api-panel="addresses"]>.mxp-page-head--row{padding-right:58px!important;align-items:flex-start!important;flex-wrap:wrap!important;gap:10px!important}}';
    document.head.appendChild(s);
  }
  async function load(){
    var A=api();
    if(!A||!A.hasSession||!A.hasSession()||typeof A.getCustomer!=='function')return null;
    try{
      var c=await A.getCustomer();
      var addresses=arr(c);
      if(addresses.length&&!(c.defaultAddress&&c.defaultAddress.id)&&!busy){
        busy=true;
        try{await A.updateAddress(addresses[0].id,undefined,true);c=await A.getCustomer()}finally{busy=false}
      }
      state=c;return c;
    }catch(e){return null}
  }
  function decorate(){
    css();
    var portal=document.getElementById('MpsApiCustomerPortal');if(!portal)return;
    var cards=Array.prototype.slice.call(portal.querySelectorAll('[data-mps-api-address-list] [data-address-id]'));
    var addresses=arr(state),defaultId=state&&state.defaultAddress&&state.defaultAddress.id;
    var onlyOne=addresses.length===1;

    cards.forEach(function(card){
      var id=card.getAttribute('data-address-id')||'';
      var isDefault=sid(id)===sid(defaultId);
      var title=card.querySelector('.mps-api-address__top strong');
      if(title)title.textContent=isDefault?'Adresse par défaut':'Adresse';

      var top=card.querySelector('.mps-api-address__top');
      var oldBadge=card.querySelector('.mxp-address-default-badge');
      if(isDefault&&!oldBadge&&top){
        var badge=document.createElement('span');badge.className='mxp-address-default-badge';badge.textContent='Par défaut';top.appendChild(badge);
      }else if(!isDefault&&oldBadge){oldBadge.remove()}

      var actions=card.querySelector('.mps-api-address__actions');
      if(actions){
        var def=actions.querySelector('[data-mxp-address-default]');
        if(!isDefault&&!def){
          def=document.createElement('button');def.type='button';def.className='mxp-address-default-action';def.setAttribute('data-mxp-address-default','1');def.textContent='Définir par défaut';
          var del=actions.querySelector('[data-mps-api-address-delete]');
          if(del)actions.insertBefore(def,del);else actions.appendChild(def);
        }else if(isDefault&&def){def.remove()}

        var delBtn=actions.querySelector('[data-mps-api-address-delete]');
        if(delBtn){
          if(onlyOne){delBtn.remove()}
          else{delBtn.hidden=false;delBtn.disabled=false}
        }
      }
    });

    var add=portal.querySelector('[data-mps-api-address-add]');
    if(add){add.style.removeProperty('visibility');add.style.removeProperty('display');add.hidden=false}

    var form=portal.querySelector('[data-mps-api-address-form-el]');
    if(form){
      ['firstName','lastName','address1','zip','city','territoryCode','phoneNumber'].forEach(function(n){if(form.elements&&form.elements[n])form.elements[n].required=true});
      var id=form.elements&&form.elements.addressId?form.elements.addressId.value:'';
      var check=form.elements&&form.elements.defaultAddress;
      if(check){
        if(addresses.length===0){check.checked=true;check.disabled=true}
        else if(id&&sid(id)===sid(defaultId)){check.checked=true;check.disabled=true}
        else{check.disabled=false}
      }
    }
  }
  async function refresh(){await load();decorate()}
  document.addEventListener('click',function(e){
    var btn=e.target&&e.target.closest&&e.target.closest('[data-mxp-address-default]');
    if(btn){
      e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
      var card=btn.closest('[data-address-id]'),id=card&&card.getAttribute('data-address-id');
      var A=api();if(!id||!A||busy)return;
      busy=true;btn.disabled=true;btn.textContent='Enregistrement…';
      A.updateAddress(id,undefined,true).then(function(){return A.getCustomer()}).then(function(c){state=c;decorate()}).catch(function(err){alert(err&&err.message?err.message:'Impossible de définir cette adresse par défaut.');btn.disabled=false;btn.textContent='Définir par défaut'}).finally(function(){busy=false});
      return;
    }
    var del=e.target&&e.target.closest&&e.target.closest('[data-mps-api-address-delete]');
    if(del&&arr(state).length<=1){
      e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
      alert('Vous devez conserver au moins une adresse. Vous pouvez la modifier.');
      return;
    }
    if(e.target&&e.target.closest&&e.target.closest('[data-mps-api-address-edit],[data-mps-api-address-add]')){
      setTimeout(decorate,0);setTimeout(decorate,80);
    }
  },true);

  document.addEventListener('submit',function(e){
    var f=e.target&&e.target.closest&&e.target.closest('[data-mps-api-address-form-el]');
    if(!f)return;
    var addresses=arr(state),check=f.elements&&f.elements.defaultAddress;
    if(check&&addresses.length===0){check.checked=true;check.disabled=false}
  },true);

  function start(){
    css();refresh();
    observer=new MutationObserver(function(){decorate()});
    observer.observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden','class']});
    timer=setInterval(function(){var p=document.querySelector('[data-mps-api-panel="addresses"]');if(p&&!p.hidden)refresh()},30000);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

/* MXP_CART_SAVED_ADDRESS_V3 */
(function(){
  if(window.__mxpCartSavedAddressV3)return;
  window.__mxpCartSavedAddressV3=true;

  var saving=false;
  var bypass=false;
  var savedThisPage=false;
  var customerCache=null;
  var liveTimer=null;
  var dirty=false;
  var lastFingerprint='';

  function q(sel,root){return (root||document).querySelector(sel)}
  function api(){return window.MaxpromoCustomerAPI||null}
  function s(v){return String(v==null?'':v).trim()}
  function addressesOf(c){var a=c&&c.addresses;return Array.isArray(a)?a:(a&&Array.isArray(a.nodes)?a.nodes:[])}
  function defaultOf(c){if(c&&c.defaultAddress)return c.defaultAddress;var a=addressesOf(c);return a.length?a[0]:null}
  function countryCode(v){
    var x=s(v).toLowerCase();
    var map={france:'FR',fr:'FR',belgique:'BE',belgium:'BE',be:'BE',luxembourg:'LU',lu:'LU',allemagne:'DE',germany:'DE',de:'DE',espagne:'ES',spain:'ES',es:'ES',italie:'IT',italy:'IT',it:'IT',suisse:'CH',switzerland:'CH',ch:'CH'};
    return map[x]||s(v).toUpperCase();
  }
  function countryLabel(v){
    var x=countryCode(v);
    return {FR:'France',BE:'Belgium',LU:'Luxembourg',DE:'Germany',ES:'Spain',IT:'Italy',CH:'Switzerland'}[x]||s(v)||'France';
  }
  function cartForm(){return q('form[data-mxp3-form]')}
  function addressInput(){var f=cartForm();return f&&q('[data-mxp3-address]',f)}
  function addressCard(){var a=addressInput();return a&&a.closest('.mxp3card')}
  function addressFields(){var c=addressCard();return c&&q('.mxp3fields',c)}
  function addressNote(){var c=addressCard();return c&&q('.mxp3note',c)}
  function saveToggle(){return q('[data-mxp-cart-save-address]')}
  function saveStatus(){return q('[data-mxp-cart-save-status]')}
  function savedSummary(){return q('[data-mxp-cart-saved-summary]')}

  function cartPayload(){
    var f=cartForm();
    if(!f)return null;
    return {
      firstName:s(q('[data-mxp3-first]',f)&&q('[data-mxp3-first]',f).value),
      lastName:s(q('[data-mxp3-last]',f)&&q('[data-mxp3-last]',f).value),
      address1:s(q('[data-mxp3-address]',f)&&q('[data-mxp3-address]',f).value),
      address2:s(q('[data-mxp3-address2]',f)&&q('[data-mxp3-address2]',f).value),
      zip:s(q('[data-mxp3-zip]',f)&&q('[data-mxp3-zip]',f).value),
      city:s(q('[data-mxp3-city]',f)&&q('[data-mxp3-city]',f).value),
      territoryCode:countryCode(q('[data-mxp3-country]',f)&&q('[data-mxp3-country]',f).value),
      phoneNumber:s(q('[data-mxp3-phone]',f)&&q('[data-mxp3-phone]',f).value)
    };
  }
  function complete(a){
    return !!(a&&s(a.firstName||a.name)&&s(a.lastName||a.name)&&s(a.address1)&&s(a.zip)&&s(a.city)&&s(a.territoryCode||a.countryCode||a.countryCodeV2||a.country)&&s(a.phoneNumber||a.phone));
  }
  function fingerprint(a){
    if(!a)return '';
    return [
      s(a.firstName||''),
      s(a.lastName||''),
      s(a.address1||''),
      s(a.address2||''),
      s(a.zip||''),
      s(a.city||''),
      countryCode(a.territoryCode||a.countryCode||a.countryCodeV2||a.country||''),
      s(a.phoneNumber||a.phone||'')
    ].join('|').toLowerCase();
  }
  function markPersisted(a){
    lastFingerprint=fingerprint(a);
    dirty=false;
    savedThisPage=true;
  }
  function value(el,v){
    if(!el)return;
    var next=s(v);
    if(el.tagName==='SELECT'){
      var wanted=countryLabel(next).toLowerCase(),code=countryCode(next).toLowerCase(),found=false;
      Array.prototype.forEach.call(el.options||[],function(o){
        if(s(o.value).toLowerCase()===wanted||s(o.value).toLowerCase()===code||s(o.textContent).toLowerCase()===wanted){el.value=o.value;found=true}
      });
      if(!found&&next){var opt=document.createElement('option');opt.value=countryLabel(next);opt.textContent=countryLabel(next);el.appendChild(opt);el.value=opt.value}
    }else el.value=next;
    try{el.dispatchEvent(new Event('input',{bubbles:true}))}catch(e){}
    try{el.dispatchEvent(new Event('change',{bubbles:true}))}catch(e){}
  }
  function fill(a){
    var f=cartForm();if(!f||!a)return;
    value(q('[data-mxp3-first]',f),a.firstName||'');
    value(q('[data-mxp3-last]',f),a.lastName||'');
    value(q('[data-mxp3-address]',f),a.address1||'');
    value(q('[data-mxp3-address2]',f),a.address2||'');
    value(q('[data-mxp3-zip]',f),a.zip||'');
    value(q('[data-mxp3-city]',f),a.city||'');
    value(q('[data-mxp3-country]',f),a.territoryCode||a.countryCode||a.countryCodeV2||a.country||'FR');
    value(q('[data-mxp3-phone]',f),a.phoneNumber||a.phone||'');
  }
  function displayName(a){return s(a&&a.name)||[s(a&&a.firstName),s(a&&a.lastName)].filter(Boolean).join(' ')}
  function summaryText(a){
    return [displayName(a),s(a&&a.address1),s(a&&a.address2),[s(a&&a.zip),s(a&&a.city)].filter(Boolean).join(' '),countryLabel(a&&a.territoryCode||a&&a.countryCode||a&&a.countryCodeV2||a&&a.country),s(a&&a.phoneNumber||a&&a.phone)].filter(Boolean);
  }
  function esc(v){
    return String(v==null?'':v).replace(/[&<>"']/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]})
  }

  function ensureCss(){
    if(document.getElementById('mxp-cart-saved-address-v3-style'))return;
    var st=document.createElement('style');st.id='mxp-cart-saved-address-v3-style';
    st.textContent=
      '.mxp-cart-save-address{display:flex!important;align-items:flex-start!important;gap:12px!important;margin:14px 0 0!important;padding:14px 16px!important;border:1px solid rgba(214,174,46,.28)!important;border-radius:16px!important;background:linear-gradient(135deg,rgba(255,252,238,.72),rgba(255,255,255,.58))!important;-webkit-backdrop-filter:blur(18px) saturate(150%)!important;backdrop-filter:blur(18px) saturate(150%)!important;box-shadow:0 12px 34px rgba(20,28,42,.045),inset 0 1px 0 rgba(255,255,255,.82)!important;color:#1c2430!important;cursor:pointer!important;transition:border-color .2s ease,background .2s ease,box-shadow .2s ease,transform .2s ease!important}' +
      '.mxp-cart-save-address:hover{border-color:rgba(214,174,46,.42)!important;background:linear-gradient(135deg,rgba(255,252,238,.82),rgba(255,255,255,.70))!important;box-shadow:0 15px 38px rgba(20,28,42,.06),inset 0 1px 0 rgba(255,255,255,.9)!important;transform:translateY(-1px)!important}' +
      '.mxp-cart-save-address input{flex:0 0 auto!important;width:20px!important;height:20px!important;margin:1px 0 0!important;accent-color:#f5b400!important;filter:drop-shadow(0 2px 5px rgba(245,180,0,.16))!important}' +
      '.mxp-cart-save-address__copy{display:flex!important;min-width:0!important;flex:1!important;flex-direction:column!important;gap:3px!important}' +
      '.mxp-cart-save-address__copy strong{font-size:11.5px!important;line-height:1.28!important;font-weight:900!important;letter-spacing:-.01em!important;color:#18202c!important}' +
      '.mxp-cart-save-address__copy small{font-size:9.8px!important;line-height:1.42!important;font-weight:650!important;color:#687383!important}' +
      '.mxp-cart-save-address__status{display:inline-flex!important;width:max-content!important;align-items:center!important;gap:6px!important;margin-top:5px!important;padding:4px 8px!important;border:1px solid rgba(117,126,140,.14)!important;border-radius:999px!important;background:rgba(255,255,255,.58)!important;color:#737d8b!important;font-size:8.7px!important;line-height:1!important;font-style:normal!important;font-weight:850!important}' +
      '.mxp-cart-save-address__status:before{content:""!important;width:6px!important;height:6px!important;border-radius:50%!important;background:#f5b400!important;box-shadow:0 0 0 3px rgba(245,180,0,.10)!important}' +
      '.mxp-cart-save-address.is-saving .mxp-cart-save-address__status:before{animation:mxpAddressPulse .85s ease-in-out infinite alternate!important}' +
      '.mxp-cart-save-address.is-saved{border-color:rgba(37,161,106,.26)!important;background:linear-gradient(135deg,rgba(242,252,247,.78),rgba(255,255,255,.68))!important}' +
      '.mxp-cart-save-address.is-saved .mxp-cart-save-address__status{color:#16784d!important;border-color:rgba(37,161,106,.18)!important}' +
      '.mxp-cart-save-address.is-saved .mxp-cart-save-address__status:before{background:#25a16a!important;box-shadow:0 0 0 3px rgba(37,161,106,.10)!important}' +
      '.mxp-cart-save-address.is-error .mxp-cart-save-address__status{color:#9c5224!important}' +
      '.mxp-cart-save-address.is-error .mxp-cart-save-address__status:before{background:#cf7b3d!important;box-shadow:0 0 0 3px rgba(207,123,61,.10)!important}' +
      '.mxp-cart-saved-summary{margin:13px 0 0!important;padding:15px 16px!important;border:1px solid rgba(37,161,106,.20)!important;border-radius:16px!important;background:linear-gradient(135deg,rgba(244,252,248,.78),rgba(255,255,255,.66))!important;-webkit-backdrop-filter:blur(18px) saturate(145%)!important;backdrop-filter:blur(18px) saturate(145%)!important;box-shadow:0 12px 34px rgba(20,28,42,.04),inset 0 1px 0 rgba(255,255,255,.82)!important}' +
      '.mxp-cart-saved-summary__head{display:flex!important;align-items:center!important;gap:9px!important;margin-bottom:8px!important}' +
      '.mxp-cart-saved-summary__check{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:22px!important;height:22px!important;border-radius:8px!important;background:rgba(37,161,106,.10)!important;color:#138354!important;font-size:12px!important;font-weight:950!important}' +
      '.mxp-cart-saved-summary strong{margin:0!important;flex:1!important;color:#18202c!important;font-size:11.8px!important;font-weight:900!important}' +
      '.mxp-cart-saved-summary__edit{appearance:none!important;border:1px solid rgba(39,52,70,.12)!important;border-radius:999px!important;background:rgba(255,255,255,.64)!important;color:#344051!important;padding:6px 10px!important;font-size:8.8px!important;font-weight:900!important;cursor:pointer!important;transition:background .18s ease,border-color .18s ease,transform .18s ease!important}' +
      '.mxp-cart-saved-summary__edit:hover{background:rgba(255,255,255,.92)!important;border-color:rgba(214,174,46,.30)!important;transform:translateY(-1px)!important}' +
      '.mxp-cart-saved-summary p{margin:0 0 0 31px!important;color:#657080!important;font-size:10.6px!important;line-height:1.55!important}' +
      '.mxp-cart-saved-summary small{display:block!important;margin:8px 0 0 31px!important;color:#28815b!important;font-size:9px!important;font-weight:800!important}' +
      '@keyframes mxpAddressPulse{from{opacity:.38;transform:scale(.86)}to{opacity:1;transform:scale(1.08)}}' +
      '@media(max-width:720px){.mxp-cart-save-address{padding:13px 14px!important;border-radius:15px!important}.mxp-cart-saved-summary{padding:14px!important}.mxp-cart-saved-summary p,.mxp-cart-saved-summary small{margin-left:0!important}.mxp-cart-saved-summary__head{flex-wrap:wrap!important}.mxp-cart-saved-summary__edit{margin-left:auto!important}}';
    document.head.appendChild(st);
  }
  function setSaveUi(state,message){
    var wrap=q('[data-mxp-cart-save-wrap]'),status=saveStatus();
    if(!wrap||!status)return;
    wrap.classList.remove('is-saving','is-saved','is-error');
    if(state==='saving')wrap.classList.add('is-saving');
    if(state==='saved')wrap.classList.add('is-saved');
    if(state==='error')wrap.classList.add('is-error');
    status.textContent=message||(
      state==='saving'?'Enregistrement automatique…':
      state==='saved'?'Adresse enregistrée':
      state==='error'?'À vérifier':
      'Enregistrement automatique'
    );
  }
  function ensureSaveControl(){
    var card=addressCard();if(!card)return;
    var old=card.querySelector('[data-mxp-cart-save-wrap]');
    if(old){old.hidden=false;setSaveUi(dirty?'ready':'idle');return}
    var label=document.createElement('label');
    label.className='mxp-cart-save-address';
    label.setAttribute('data-mxp-cart-save-wrap','1');
    label.innerHTML='<input type="checkbox" data-mxp-cart-save-address checked required><span class="mxp-cart-save-address__copy"><strong>Enregistrer cette adresse dans mon compte</strong><small>Elle sera ajoutée à “Mes adresses”, définie par défaut et utilisée automatiquement lors du paiement Shopify.</small><em class="mxp-cart-save-address__status" data-mxp-cart-save-status>Enregistrement automatique</em></span>';
    var note=addressNote();if(note)note.insertAdjacentElement('afterend',label);else card.appendChild(label);
  }
  function removeSaveControl(){var x=q('[data-mxp-cart-save-wrap]');if(x)x.remove()}
  function showUnsaved(editing){
    ensureCss();
    var fields=addressFields(),note=addressNote(),sum=savedSummary();
    if(fields)fields.style.removeProperty('display');
    if(note)note.style.removeProperty('display');
    if(sum)sum.remove();
    ensureSaveControl();
    if(editing){dirty=false;lastFingerprint=fingerprint(cartPayload());setSaveUi('idle','Les modifications seront enregistrées automatiquement')}
  }
  function showSaved(a){
    ensureCss();
    clearTimeout(liveTimer);
    markPersisted(a);
    fill(a);
    var card=addressCard(),fields=addressFields(),note=addressNote();if(!card)return;
    if(fields)fields.style.display='none';
    if(note)note.style.display='none';
    removeSaveControl();
    var old=savedSummary();if(old)old.remove();
    var box=document.createElement('div');box.className='mxp-cart-saved-summary';box.setAttribute('data-mxp-cart-saved-summary','1');
    box.innerHTML='<div class="mxp-cart-saved-summary__head"><span class="mxp-cart-saved-summary__check">✓</span><strong>Adresse enregistrée</strong><button type="button" class="mxp-cart-saved-summary__edit" data-mxp-cart-edit-address>Modifier</button></div><p>'+summaryText(a).map(esc).join('<br>')+'</p><small>Adresse par défaut MAXPROMO · synchronisée avec “Mes adresses”.</small>';
    var head=card.querySelector('.mxp3head');if(head)head.insertAdjacentElement('afterend',box);else card.insertBefore(box,card.firstChild);
    var edit=q('[data-mxp-cart-edit-address]',box);
    if(edit)edit.addEventListener('click',function(){showUnsaved(true)});
  }
  function previewSaved(){var p=window.__MPS_PREVIEW_CUSTOMER;return !!(p&&p.loggedIn&&Array.isArray(p.addresses)&&p.addresses.length)}
  function previewSavedComplete(){var p=cartPayload();return previewSaved()&&!!(p&&complete(p))}
  function nativeTemplate(){var t=document.getElementById('MpsPreviewAddressNewTemplate');if(!t)return null;return t.content?t.content.querySelector('form'):t.querySelector('form')}
  function hasSaved(){return savedThisPage||!!(customerCache&&addressesOf(customerCache).length&&complete(defaultOf(customerCache)))||previewSavedComplete()}

  async function loadCustomer(){
    var A=api();
    if(!A||!A.hasSession||!A.hasSession()||typeof A.getCustomer!=='function')return null;
    var c=await A.getCustomer();
    var list=addressesOf(c);
    if(list.length&&!(c.defaultAddress&&c.defaultAddress.id)&&typeof A.updateAddress==='function'){
      await A.updateAddress(list[0].id,undefined,true);
      c=await A.getCustomer();
    }
    customerCache=c;return c;
  }
  async function applyState(){
    if(!cartForm())return;
    ensureCss();
    try{
      var c=await loadCustomer();
      var d=defaultOf(c);
      if(d&&complete(d)){showSaved(d);return}
    }catch(e){}
    if(previewSaved()){
      var pp=cartPayload();
      if(pp&&complete(pp)){markPersisted(pp);showSaved(pp);return}
    }
    savedThisPage=false;
    lastFingerprint='';
    dirty=false;
    showUnsaved(false);
  }
  async function saveViaApi(payload){
    var A=api();if(!A||!A.hasSession||!A.hasSession())return null;
    var d=defaultOf(customerCache);
    if(d&&d.id&&typeof A.updateAddress==='function')await A.updateAddress(d.id,payload,true);
    else await A.createAddress(payload,true);
    var c=await A.getCustomer();
    customerCache=c;
    return defaultOf(c)||payload;
  }
  async function saveViaNative(payload){
    var src=nativeTemplate();if(!src)return null;
    var f=src.cloneNode(true);
    function set(name,val){var el=f.elements&&f.elements[name];if(el)el.value=val||''}
    set('address[first_name]',payload.firstName);
    set('address[last_name]',payload.lastName);
    set('address[address1]',payload.address1);
    set('address[address2]',payload.address2);
    set('address[zip]',payload.zip);
    set('address[city]',payload.city);
    set('address[phone]',payload.phoneNumber);
    var country=f.elements&&f.elements['address[country]'];if(country)country.value=countryLabel(payload.territoryCode);
    var cb=f.querySelector('.mps-api-check input[type="checkbox"]');if(cb)cb.checked=true;
    var fd=new FormData(f);
    var res=await fetch(f.action,{method:(f.method||'post').toUpperCase(),body:fd,credentials:'same-origin',redirect:'follow'});
    if(!res.ok)throw new Error('Impossible d’enregistrer cette adresse.');
    return payload;
  }
  async function persistAddress(options){
    options=options||{};
    var payload=cartPayload();
    if(!complete(payload)){
      if(!options.live){var form=cartForm();if(form&&form.reportValidity)form.reportValidity()}
      return false;
    }
    var check=saveToggle();
    if(check&&!check.checked){
      if(!options.live){check.focus();if(check.reportValidity)check.reportValidity()}
      return false;
    }
    var currentFingerprint=fingerprint(payload);
    if(currentFingerprint&&currentFingerprint===lastFingerprint&&!dirty){
      if(options.collapse!==false)showSaved(payload);
      return true;
    }
    setSaveUi('saving','Enregistrement automatique…');
    var a=null;
    try{a=await saveViaApi(payload)}catch(e){a=null}
    if(!a){try{a=await saveViaNative(payload)}catch(e){if(options.live){setSaveUi('error','Enregistrement au paiement');return false}throw e}}
    if(!a){
      if(options.live){setSaveUi('error','Enregistrement au paiement');return false}
      throw new Error('Connectez-vous à votre compte MAXPROMO pour enregistrer cette adresse.');
    }
    markPersisted(a);
    setSaveUi('saved','Adresse enregistrée');
    try{window.dispatchEvent(new CustomEvent('mps:customer-addresses-updated',{detail:{address:a}}))}catch(e){}
    if(options.collapse!==false){
      setTimeout(function(){showSaved(a)},220);
    }
    return true;
  }
  function relevantField(target){
    return !!(target&&target.matches&&target.matches('[data-mxp3-first],[data-mxp3-last],[data-mxp3-address],[data-mxp3-address2],[data-mxp3-zip],[data-mxp3-city],[data-mxp3-country],[data-mxp3-phone]'));
  }
  function scheduleLiveSave(delay){
    clearTimeout(liveTimer);
    var payload=cartPayload(),check=saveToggle();
    if(!payload||!complete(payload)||!check||!check.checked)return;
    dirty=fingerprint(payload)!==lastFingerprint;
    if(!dirty){setSaveUi('saved','Adresse déjà enregistrée');return}
    setSaveUi('idle','Prête à être enregistrée');
    liveTimer=setTimeout(function(){
      if(saving)return;
      saving=true;
      persistAddress({live:true,collapse:true}).finally(function(){saving=false});
    },delay==null?1100:delay);
  }
  function isCheckoutSubmit(ev){
    var f=ev.target;if(!f||!f.matches||!f.matches('form[data-mxp3-form]'))return false;
    var b=ev.submitter||document.activeElement;
    return !!(b&&(String(b.name||'')==='checkout'||b.matches&&b.matches('[data-mxp3-checkout]')));
  }

  document.addEventListener('input',function(ev){
    if(!relevantField(ev.target))return;
    dirty=fingerprint(cartPayload())!==lastFingerprint;
    scheduleLiveSave(1200);
  },true);
  document.addEventListener('change',function(ev){
    if(ev.target&&ev.target.matches&&ev.target.matches('[data-mxp-cart-save-address]')){
      if(ev.target.checked)scheduleLiveSave(120);
      else setSaveUi('idle','Cochez pour enregistrer cette adresse');
      return;
    }
    if(!relevantField(ev.target))return;
    dirty=fingerprint(cartPayload())!==lastFingerprint;
    scheduleLiveSave(260);
  },true);

  document.addEventListener('submit',function(ev){
    if(bypass||saving||!isCheckoutSubmit(ev))return;
    var payload=cartPayload();
    var mustPersist=dirty||!hasSaved()||(payload&&fingerprint(payload)!==lastFingerprint);
    if(!mustPersist)return;
    ev.preventDefault();ev.stopPropagation();ev.stopImmediatePropagation();
    clearTimeout(liveTimer);
    saving=true;
    var f=ev.target,b=ev.submitter||document.activeElement;
    persistAddress({live:false,collapse:false}).then(function(ok){
      if(!ok)return;
      bypass=true;
      try{if(f.requestSubmit)f.requestSubmit(b&&b.form===f?b:undefined);else f.submit()}finally{setTimeout(function(){bypass=false},0)}
    }).catch(function(err){alert(err&&err.message?err.message:'Impossible d’enregistrer cette adresse.')}).finally(function(){saving=false});
  },true);

  function start(){applyState()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  window.addEventListener('pageshow',applyState);
  window.addEventListener('mps:customer-authenticated',function(){customerCache=null;setTimeout(applyState,100)});
})();